import { postJSON } from 'common/services/api'
import { useMutation } from 'react-query'
import { handleErrorResponse } from 'utils/error'
import type { CSV_EXPORT_TYPE } from '../utils'

export const useGenerateCsv = (
  CSVExportType?: CSV_EXPORT_TYPE,
  onSuccess?: () => void
) => {
  const mutationFunction = (
    body: object
  ): Promise<{ result: { message: string } }> =>
    postJSON({
      url: `services/csv/export/${CSVExportType}`,
      json: body,
      method: 'POST'
    })

  const { mutateAsync, isLoading, error } = useMutation(mutationFunction, {
    onSuccess
  })

  return {
    isLoading,
    generate: mutateAsync,
    error: handleErrorResponse(error)
  }
}
